import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { saveNewMajorOperation } from '../operations/save-new-major-operation';

interface AddNewMajorDialogDataModel {
  onHide: () => any;
}
export const AddNewMajorDialog: React.FC<AddNewMajorDialogDataModel> = ({
  onHide,
}) => {
  const [majorName, setMajorName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    await saveNewMajorOperation(majorName, setLoading);
    onHide();
  };
  return (
    <div>
      <EditText
        title={'הזן את שם המגמה'}
        value={majorName}
        onChange={setMajorName}
      />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          style={{ height: '30px' }}
          onClick={handleSave}
          label={'אישור'}
          loading={loading}
        />
      </div>
    </div>
  );
};
